// extracted by mini-css-extract-plugin
export default {"parent":"formUpload_parent__qMO6u","parentErrorInform":"formUpload_parentErrorInform__m1B6F"};